import SectionLabel from "@/components/base/SectionLabel";
import { messageSupportData } from "@/mocks/aboutData";

export default function MessageSupportSection() {
  return (
    <section id="message" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal max-w-4xl mx-auto">
          {/* Section header */}
          <div className="mb-8 md:mb-10">
            <SectionLabel label={messageSupportData.label} className="mb-3" />
            <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900">
              {messageSupportData.heading}
            </h2>
          </div>

          {/* Message body + photo placeholder */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-10 mb-12 md:mb-16">
            <div className="md:col-span-3">
              <div className="space-y-4 md:space-y-5 text-sm md:text-base text-foreground-700 leading-[2]">
                {messageSupportData.paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>

              <div className="mt-7 md:mt-9 pt-6 md:pt-7 border-t border-background-200/70">
                <p className="text-sm text-foreground-900 font-bold font-heading">
                  {messageSupportData.title}
                </p>
                <p className="text-xs md:text-sm text-foreground-600 mt-1">
                  {messageSupportData.name}
                </p>
              </div>
            </div>

            <div className="md:col-span-2 flex flex-col items-center">
              <div className="w-full max-w-[240px] aspect-[3/4] bg-background-100 border border-background-200/70 rounded-lg flex flex-col items-center justify-center overflow-hidden">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-secondary-100 flex items-center justify-center mb-3">
                  <i className="ri-user-3-line text-xl md:text-2xl text-secondary-400" />
                </div>
                <span className="text-xs text-foreground-500 text-center leading-relaxed px-3">
                  {messageSupportData.photoDescription}
                </span>
              </div>
            </div>
          </div>

          {/* Support system */}
          <div className="reveal max-w-3xl mx-auto">
            <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8">
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 md:mb-4">
                {messageSupportData.supportHeading}
              </h3>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6 md:mb-7">
                {messageSupportData.supportText}
              </p>

              {/* Support flow diagram */}
              <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-4">
                {messageSupportData.supportSteps.map((step, idx) => (
                  <div key={idx} className="flex items-center gap-3 md:gap-4">
                    <div className={`flex flex-col items-center gap-2 px-4 py-3 md:px-5 md:py-4 rounded-lg border ${idx === 1 ? "bg-primary-50/70 border-primary-200/50" : "bg-background-50 border-background-200/70"}`}>
                      <div className={`w-9 h-9 rounded-full flex items-center justify-center ${idx === 0 ? "bg-accent-100" : idx === 1 ? "bg-primary-100" : "bg-secondary-100"}`}>
                        <i className={`${step.icon} text-sm ${idx === 0 ? "text-accent-600" : idx === 1 ? "text-primary-600" : "text-secondary-600"}`} />
                      </div>
                      <span className="text-xs md:text-sm font-medium text-foreground-800 text-center leading-snug whitespace-pre-line">
                        {step.label}
                      </span>
                    </div>

                    {idx < messageSupportData.supportSteps.length - 1 && (
                      <div className="flex-shrink-0">
                        <i className="ri-arrow-down-line md:ri-arrow-right-line text-foreground-400" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}